import type { IServerSideGetRowsRequest } from 'ag-grid-community'
import { type InferResponse, fetchClient } from '../../typedClient'

export type TankReadingsFindResponse = InferResponse<
  '/crossroads/tank_readings/find',
  'post'
>
export type TankReadingsOverviewRow = NonNullable<
  TankReadingsFindResponse['rowData']
>[number]
export type TankPerspectiveLabels = TankReadingsOverviewRow['internal']

/** Rows fetched per server page. The backend caps a `/find` response at 1000. */
export const TANK_READINGS_PAGE_SIZE = 1000

/**
 * Business filters for the tank-readings grid. The Data Format perspective is a
 * client-side display choice (rows carry all three label-sets), so it is NOT a
 * filter here — only true server-side filters belong in this object.
 */
export interface TankReadingsFilters {
  partnerTenantId?: string
}

/**
 * SSRM fetch function (a plain async function, not a hook) for
 * {@link useServerSideDataSource}. Maps the AG Grid request block + debounced
 * search + business filters onto `POST /crossroads/tank_readings/find`.
 */
export async function fetchTankReadings({
  filters,
  search,
  request,
}: {
  filters: TankReadingsFilters
  search: string
  request: IServerSideGetRowsRequest & { includeCount?: boolean }
}): Promise<{ rowData: TankReadingsOverviewRow[]; rowCount: number }> {
  const { data, error } = await fetchClient.POST(
    '/crossroads/tank_readings/find',
    {
      body: {
        ...request,
        search,
        partnerTenantId: filters.partnerTenantId,
      },
    },
  )
  if (error) throw error
  return {
    rowData: data?.rowData ?? [],
    rowCount: data?.rowCount ?? -1,
  }
}
